import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const runPACreateService = (params: Types.RunPACreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPACheckRuleService = (params: Types.RunPACheckRuleRequest) =>
  RestAPIClient.call<Types.RunPACheckRuleResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.CheckRule,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const runPALockDataAllService = (params: Types.RunPALockDataRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPALockDataUpdateService = (
  params: Types.RunPALockDataUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPACheckLockDataService = (
  params: Types.RunPACheckLockDataRequest
) =>
  RestAPIClient.call<Types.RunPACheckLockDataResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const runPA13thMonthSalaryService = (params: {
  year: number;
  autoReceiveEmployeeCodes?: string[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create13ThMonthSalary,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
